import { AHSeparator, ListItem } from "arkh";
import React, { useCallback, useMemo } from "react";
import { graphql, usePaginationFragment } from "react-relay";
import { FlashList } from "@shopify/flash-list";
import { ActionFooter } from "@/src/components/ActionFooter";
import { keyExtractorId } from "@/src/common/keyExtractors";
import { UserAdminGroupDevices_store$key } from "./__generated__/UserAdminGroupDevices_store.graphql";
import { FlatList, Platform } from "react-native";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";

export function UserAdminGroupDevices(props: {
  store: UserAdminGroupDevices_store$key;
  createGroupDevice: () => void;
  isCreatingAuthRequest: boolean;
  openEditGroupDevice: (id: string) => void;
}) {
  const intl_tokens = useIntlTokens();
  const { data, loadNext, hasNext } = usePaginationFragment(
    graphql`
      fragment UserAdminGroupDevices_store on Store
      @refetchable(queryName: "UserAdminGroupDevicesPaginationQuery") {
        id
        sharedMobileDevices(first: $first, after: $after)
          @connection(key: "UserAdminGroupDevices_store_sharedMobileDevices") {
          edges {
            node {
              id
              name
              lastUsedAtDate {
                storeFormattedDate(style: DATE_ONLY)
              }
            }
          }
        }
      }
    `,
    props.store
  );

  const listData = useMemo(() => {
    return data.sharedMobileDevices.edges.map((e) => e.node);
  }, [data.sharedMobileDevices.edges]);

  const renderItem = useCallback(
    ({ item }: { item: (typeof listData)[number] }) => {
      return (
        <ListItem
          right={<ListItem.NavArrow />}
          onPress={() => {
            props.openEditGroupDevice(item.id);
          }}
        >
          <ListItem.Title>{item.name}</ListItem.Title>
          {item.lastUsedAtDate ? (
            <ListItem.SubTitle>
              {item.lastUsedAtDate.storeFormattedDate}
            </ListItem.SubTitle>
          ) : null}
        </ListItem>
      );
    },
    [props]
  );

  return (
    <>
      {Platform.OS === "web" ? (
        <FlatList
          data={listData}
          renderItem={renderItem}
          keyExtractor={keyExtractorId}
          ItemSeparatorComponent={() => <AHSeparator />}
          onEndReached={() => {
            if (hasNext) {
              loadNext(20);
            }
          }}
          onEndReachedThreshold={0.5}
          keyboardShouldPersistTaps="handled"
        />
      ) : (
        <FlashList
          data={listData}
          renderItem={renderItem}
          keyExtractor={keyExtractorId}
          ItemSeparatorComponent={() => <AHSeparator />}
          onEndReached={() => {
            if (hasNext) {
              loadNext(20);
            }
          }}
          onEndReachedThreshold={0.5}
          keyboardShouldPersistTaps="handled"
        />
      )}
      <ActionFooter
        primary={
          <ActionFooter.Primary
            title={intl_tokens.AddSharedDevice}
            icon="group-actor"
            loading={props.isCreatingAuthRequest}
            onPress={() => {
              props.createGroupDevice();
            }}
          />
        }
      />
    </>
  );
}
